import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import { graphql } from 'gatsby';
import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';
import Checklist from '../components/scenes/Checklist/Checklist';

const condition = authUser => !!authUser;
const ChecklistPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(Checklist);

export default () => {
  return (
    <Layout>
      <ChecklistPage>
          Add a checkbox list of things that need completing
        </ChecklistPage>
    </Layout>
  );
};

export const query = graphql`
  query ChecklistSeo {
    site {
      siteMetadata {
        home {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
          twitterUsername
        }
      }
    }
  }
`;
